import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { Form, OptionToggleGroup } from 'components';
import SelectItemsModal from 'pages/ModulePage/components/SelectItemsModal/SelectItemsModal';
import SelectedItems from 'pages/ModulePage/components/SelectedItems/SelectedItems';
import { useFormikContext } from 'formik';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDisplayDate } from 'utils/date';
import { EVENT_MODES } from './constants';

const getEventKey = (event) => event.uid;

const filterEventBySearch = (event, query) =>
  event.name.toLowerCase().includes(query.toLowerCase());

const getEventItemCardProps = (event, { t }) => ({
  imageSrc: event.owner.picture || placeholderImage,
  imageAlt: event.name,
  title: event.name,
  meta: [
    {
      label: t('eventDate'),
      value: formatDisplayDate(event.date, t('notSpecified')),
    },
  ],
});

export const createEventsConfig = (useAvailableItems) => {
  const EventsConfig = () => {
    const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });
    const { values, setFieldValue } = useFormikContext();
    const { items, isLoading } = useAvailableItems();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [search, setSearch] = useState('');

    const selectedItems = useMemo(() => values.selectedItems || [], [values.selectedItems]);
    const filteredItems = useMemo(() => {
      if (!search.trim()) return items;
      return items.filter((event) => filterEventBySearch(event, search.trim()));
    }, [items, search]);
    const toggleOptions = useMemo(
      () => [
        {
          value: EVENT_MODES.MANUAL,
          title: t('eventModeManual'),
          description: t('eventModeManualDescription'),
        },
        {
          value: EVENT_MODES.UPCOMING,
          title: t('eventModeUpcoming'),
          description: t('eventModeUpcomingDescription'),
        },
      ],
      [t],
    );

    return (
      <>
        <Form.GroupHorizontal label={t('eventMode')}>
          <OptionToggleGroup
            value={values.mode}
            onChange={(mode) => setFieldValue('mode', mode)}
            options={toggleOptions}
          />
        </Form.GroupHorizontal>

        {values.mode === EVENT_MODES.MANUAL && (
          <>
            <Form.GroupHorizontal label={t('selectedItems')}>
              <SelectedItems
                isLoading={isLoading}
                items={selectedItems}
                setItems={(next) => setFieldValue('selectedItems', next)}
                getItemKey={getEventKey}
                getItemCardProps={getEventItemCardProps}
                onOpenModal={() => setIsModalOpen(true)}
              />
            </Form.GroupHorizontal>
            <SelectItemsModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSelect={(next) => setFieldValue('selectedItems', next)}
              initialSelected={selectedItems}
              items={filteredItems}
              isLoading={isLoading}
              getItemKey={getEventKey}
              getItemCardProps={getEventItemCardProps}
              onSearch={setSearch}
            />
          </>
        )}
      </>
    );
  };

  return EventsConfig;
};
